import * as React from 'react';
import {Button} from 'antd';
import ModulesAction from './Modules.Action';

const InvalidBtn = (props) => {
    const { noticeBillState,  } = props.detailInfo;
    const {toInvalid} = props;
    if (
        noticeBillState === 'NOTSEND' ||
        noticeBillState === 'REFUSED'
    ) {
        return (
            <Button
                className="mr10"
                type="primary"
                onClick={toInvalid}
            >
                作废
            </Button>
        );
    } else {
        return null;
    }
};
const FinishBtn = (props) => {
    const  { noticeBillState, billMatchState, noticeId } = props.detailInfo;
    if (billMatchState === 'MATCHFINISH') {
        return null;
    } else {
        if (noticeBillState !== 'REFUSED' && noticeBillState !== 'INVALID' && noticeBillState !== 'SENDED') {
            return (
                <Button
                    className="mr10"
                    type="primary"
                    onClick={()=>{ModulesAction.handleFinish(noticeId);}}
                >
                    匹配完成
                </Button>
            );
        } else {
            return null;
        }
    }
};

const MatchBtn = (props) => {
    const { noticeBillState, billMatchState, noticeId} = props.detailInfo;
    if (billMatchState === 'MATCHFINISH') {
        return null;
    } else {
        if (
            noticeBillState === 'CREATED' ||
            noticeBillState === 'SENDED' ||
            noticeBillState === 'NOTSEND' ||
            noticeBillState === 'ACCEPTED'
        ) {
            return (
                <Button className="mr10" type="primary" onClick={()=>{ModulesAction.goMatch(noticeId);}}>
                    匹配发票
                </Button>
            );
        } else {
            return null;
        }
    }
};
const DetailBtn = (props) => {
    const { billMatchState,noticeId } = props.detailInfo;
    if (billMatchState === 'MATCHFINISH') {
        return (
            <Button className="mr10" type="primary" onClick={()=>{ModulesAction.goViewMatch(noticeId);}}>
                查看匹配详情
            </Button>
        );
    } else {
        return null;
    }
};
export {InvalidBtn,FinishBtn, MatchBtn, DetailBtn};




// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.Detail.Btn.tsx